import * as C from "@radix-ui/react-checkbox"
import { CheckIcon } from "@radix-ui/react-icons"
import { tv } from "@utils/tw"
import { ReactNode, useId } from "react"

type CheckboxProps = {
  name?: string
  label?: ReactNode
  description?: ReactNode
  checked?: boolean
  required?: boolean
  onCheckedChange?: (checked: boolean) => void
}

export function Checkbox(props: CheckboxProps) {
  const id = useId()
  const styles = checkboxStyles({
    hasLabel: Boolean(props.label),
  })
  return (
    <div className={styles.wrapper()}>
      <C.Root
        name={props.name}
        required={props.required}
        className={styles.box()}
        checked={props.checked}
        onCheckedChange={props.onCheckedChange}
        id={id}
      >
        <C.Indicator>
          <CheckIcon className={styles.icon()} />
        </C.Indicator>
      </C.Root>
      {props.label && (
        <div className={styles.label()}>
          <label htmlFor={id} className="cursor-pointer">
            {props.label}
          </label>
        </div>
      )}
      {props.description && <div className={styles.description()}>{props.description}</div>}
    </div>
  )
}

export const checkboxStyles = tv({
  slots: {
    wrapper: "",
    box: [
      "relative col-span-1 col-start-1 row-start-1 size-[16px] lg:size-3 flex items-center justify-center flex-none",
      "focus-visible:ring-input outline-none",
      "text-fg-secondary border border-bg-high bg-bg-low rounded-[4px]",
      "data-[state=checked]:bg-fg data-[state=checked]:text-bg data-[state=checked]:border-fg",
      "before:absolute before:-inset-1 before:-right-3 before:block",
      "flex-none",
    ],
    info: "flex flex-col gap-2",
    label: "col-span-1 col-start-2 row-start-1 type-label-m flex items-center",
    description: "col-span-1 col-start-2 row-start-2 type-label-m text-black/40 max-w-[40em] text-pretty",
    icon: "!size-[15px]",
  },
  variants: {
    hasLabel: {
      true: {
        wrapper: "grid gap-x-3 gap-y-2 grid-cols-[auto,1fr] items-center",
      },
    },
  },
})
